<template>
    <div id="account">
        
        <div class="connected" v-if="user">
            <div class="banniere">
                <h1>MON COMPTE</h1>
            </div>
            <div class="welcome">
                Bonjour <b>{{user.username}}</b><br><br>
                Vous êtes connecté, bonne visite.
            </div>
         
            
            <div class="fav">
                <h3>Vos favoris</h3>
                <ProductsGrid  :productsArray="cardArray"/>

            </div>
        </div>
        <div v-else class="connexion">
            <h1>CONNEXION</h1>
            <LoginForm v-on:login="getLoginPayload"/>
            <span style="color:red">{{errorMessage}}</span>
        </div>
    </div>
</template>

<script>
    import ApiAuthentication from "@/mixins/ApiAuthentication";
    import LoginForm from "../components/LoginForm"
    import ProductsGrid from "../components/ProductsGrid"
    import ApiProduct from  "../mixins/ApiProducts"
    import Card from "../mixins/Card";


    export default {
        components:{
            LoginForm,
            ProductsGrid
        },
        data: function(){
            return{
                password:"",
                userName :"",
                cardArray:[],
                errorMessage:"",
                user :null
            }
        },
        methods:{
            getLoginPayload: function(username,password){
                this.getToken().then(res=>{
                    let token =res;
                    this.getLogin(username,password,res).then(data=> {
                        if(data.success){
                            this.getDetails(res).then(res => {
                                localStorage.setItem('userSettings', JSON.stringify({request_token : token,data:res}));
                              this.user = this.$store.state.user.data
                        
                            })
                        }else{
                            this.errorMessage = data.status_message
                        }
                    
                    })
                })
            },
           
        },
        created(){
            this.cardArray = this.getCart();
    
        },
        watch:{
            user : function(){
                this.$store.state.user.data
            }
        },
        mixins:[ApiAuthentication,ApiProduct,Card]
    }
</script>

<style lang="scss" scoped>
#account{
    display: flex;
    justify-content: center;
    padding:25px;
    .connexion{
        color:white;
        text-align: center;
    }
    .connected{
      flex:1;
        color:white;
        padding:25px;
        .banniere{
            flex:1;
            text-align: center;
        }
        .welcome{
            text-align: center;
        }
    }
    
}


</style>